module.exports = __webpack_public_path__ + "static/media/icon-popup-image.6afb3374.svg";